import { useEffect, useState } from 'react';
import { useGetTicker } from '../../hooks/useTradeStation';
import { pointValueFromDetails, tickSizeFromDetails } from '../engine/instrument';

export function useBacktestInstrument(ticker) {
  const { getTicker } = useGetTicker();
  const [details, setDetails] = useState(null);
  const [ready, setReady] = useState(!ticker);

  useEffect(() => {
    const symbol = String(ticker || '').trim();
    if (!symbol) {
      setDetails(null);
      setReady(true);
      return undefined;
    }
    let cancelled = false;
    setReady(false);
    getTicker(symbol)
      .then((data) => {
        if (!cancelled) setDetails(data?.Symbols?.[0] || null);
      })
      .catch(() => {
        if (!cancelled) setDetails(null);
      })
      .finally(() => {
        if (!cancelled) setReady(true);
      });
    return () => {
      cancelled = true;
    };
  }, [getTicker, ticker]);

  return {
    details,
    ready,
    pointValue: pointValueFromDetails(details),
    tickSize: tickSizeFromDetails(ticker, details),
  };
}
